import { useState } from "react";
import { ShoppingCart, X, Plus, Minus, Trash2, Package } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatPrice } from "./shopData";
import CheckoutForm from "./CheckoutForm";

export default function CartSidebar({ cart, isOpen, onClose }) {
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60]" data-testid="cart-sidebar">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-full max-w-md bg-[#0D0D0D] border-l border-[#1E1E1E] flex flex-col">
        <div className="flex items-center justify-between p-5 border-b border-[#1E1E1E]">
          <h2 className="text-white font-bold flex items-center gap-2.5">
            <ShoppingCart size={20} className="text-[#FF3B30]" />
            Winkelwagen ({cart.count})
          </h2>
          <button onClick={onClose} className="text-[#666] hover:text-white transition-colors" data-testid="close-cart-btn"><X size={20} /></button>
        </div>

        {checkoutOpen ? (
          <CheckoutForm cart={cart} onBack={() => setCheckoutOpen(false)} onClose={onClose} />
        ) : (
          <>
            <div className="flex-1 overflow-y-auto p-4 space-y-2.5">
              {cart.items.length === 0 ? (
                <div className="text-center py-16">
                  <ShoppingCart size={48} className="text-[#1E1E1E] mx-auto mb-4" />
                  <p className="text-[#666]">Je winkelwagen is leeg</p>
                </div>
              ) : (
                cart.items.map((item) => (
                  <div key={item.slug} className="flex items-center gap-3 bg-[#111] rounded-lg p-3 border border-[#1E1E1E]">
                    <div className="w-14 h-14 bg-white rounded-lg flex-shrink-0 flex items-center justify-center overflow-hidden">
                      {item.image_url ? <img src={item.image_url} alt="" className="w-full h-full object-contain p-1" /> : <Package size={18} className="text-gray-400" />}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-white text-xs font-medium truncate">{item.title}</p>
                      <p className="text-[#FF3B30] text-sm font-bold mt-1">{formatPrice(item.price * item.quantity)}</p>
                    </div>
                    <div className="flex items-center gap-1">
                      <button onClick={() => cart.updateQuantity(item.slug, item.quantity - 1)} className="w-7 h-7 rounded-md bg-[#1E1E1E] flex items-center justify-center text-white hover:bg-[#FF3B30]/20 transition-colors" data-testid={`qty-minus-${item.slug}`}><Minus size={12} /></button>
                      <span className="text-white text-sm w-6 text-center font-medium">{item.quantity}</span>
                      <button onClick={() => cart.updateQuantity(item.slug, item.quantity + 1)} className="w-7 h-7 rounded-md bg-[#1E1E1E] flex items-center justify-center text-white hover:bg-[#FF3B30]/20 transition-colors" data-testid={`qty-plus-${item.slug}`}><Plus size={12} /></button>
                      <button onClick={() => cart.removeItem(item.slug)} className="w-7 h-7 rounded-md flex items-center justify-center text-[#666] hover:text-[#FF3B30] ml-1 transition-colors" data-testid={`remove-item-${item.slug}`}><Trash2 size={14} /></button>
                    </div>
                  </div>
                ))
              )}
            </div>
            {cart.items.length > 0 && (
              <div className="border-t border-[#1E1E1E] p-5 space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-[#888]">Totaal</span>
                  <span data-testid="cart-total" className="text-white text-2xl font-bold">{formatPrice(cart.total)}</span>
                </div>
                <Button data-testid="checkout-btn" onClick={() => setCheckoutOpen(true)} className="w-full bg-[#FF3B30] hover:bg-[#E0342A] text-white py-5 font-bold uppercase tracking-wider rounded-lg transition-all hover:shadow-[0_0_20px_rgba(255,59,48,0.3)]">
                  Afrekenen
                </Button>
                <p className="text-[#555] text-[10px] text-center">iDEAL · Creditcard · Bancontact</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
